import { getDocCMS } from 'app/modules/cms/service/cmsService';
import { getActiveSubscriptionByClient, recoverAndActiveSubscriptionsClients } from 'app/modules/contract/service';
import { getSubscriptionsList } from 'app/modules/contract/service/store/selectors';
import { getAccount } from 'app/modules/user/service/store/selectors';
import ConfComp from 'app/shared/components/common/conf-component';
import AvatarWithBadge from 'app/shared/components/mobile/avatar-with-badge/avatar-with-badge';
import HomeSkeleton from 'app/shared/components/skeleton/home/home';
import { IRootState } from 'app/shared/reducers';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './contract.scss';

import { ACTION_TYPES } from 'app/modules/account/service/store/actions';
import { declarerSinistre, emptyRedirectLink, getclaimsListBySubscriptionNumber } from 'app/modules/claim/service';
import {
  getContractEngineSelector,
  getContractStatusCms,
  getHomeInfoSelector,
  getModalInformationButton,
} from 'app/modules/cms/service/store/selectors';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { RulesContext } from 'app/modules/rules/domain/RulesContext';
import { View } from 'app/modules/rules/domain/View';
import { getDataView } from 'app/modules/rules/service/rulesService';
import { getDataViewRules, getRulesDataByKey } from 'app/modules/rules/service/store/selectors';
import ErrorModal from 'app/shared/components/common/error-modal/error-modal';
import { useHistory } from 'react-router-dom';
import ModalWithAction from 'app/shared/components/common/modal/modal-with-Action';

const Home = () => {
  const rulesContext: RulesContext = {
    key: RulesKeys.GET_VIEW_DATA_CONFIGURATION,
    entryDataRules: { view: View.HOME },
  };
  const [height, setHeight] = useState(0);
  const [isReady, setReady] = useState(0);
  const refHeight = useRef(null);
  const subscriptionList: any = useSelector(getSubscriptionsList);
  const redirectLink: any = useSelector<IRootState>(state => state.claim.redirectLink);
  const avatar: any = useSelector<IRootState>(state => state.global.avatar);
  const loading: any = useSelector<IRootState>(state => state.contract.loading);
  const account = useSelector(getAccount);
  const homeCmsData: any = useSelector(getHomeInfoSelector);
  const contractCmsData: any = useSelector(getContractEngineSelector);
  const contractCustomerCms: any = useSelector(getContractStatusCms);
  const viewDataitems = useSelector(getDataViewRules(View.HOME));
  const claimsList: any = useSelector<IRootState>(state => state.claim.fullClaimList);
  const claimLoading: any = useSelector<IRootState>(state => state.claim.loading);
  const dataConfList: any = useSelector<IRootState>(state => state.rules.dataConfList);
  const multiClaims = dataConfList.get('GET_CONF')?.multiClaims;
  const rulesDataResponse = useSelector(getRulesDataByKey(RulesKeys.GET_CONF));
  const searchLink = rulesDataResponse?.composeApp?.SEARCH_NAV;
  const cmsModalInformation: any = useSelector(getModalInformationButton);

  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const history = useHistory();

  const getClaims = (sub: any) => {
    dispatch(getclaimsListBySubscriptionNumber(sub));
  };
  function getAvatarText() {
    if (subscriptionList?.length > 0) {
      let AvatarTitle = homeCmsData?.avatarText;
      AvatarTitle = AvatarTitle?.replace('{nb_adhesion}', (subscriptionList || [])?.length + '');
      return (subscriptionList || [])?.length > 1 ? AvatarTitle?.replace('{s}', 's') : AvatarTitle?.replace('{s}', '');
    }
    if (subscriptionList?.length === 0) {
      return homeCmsData?.avatarTextEmptyList;
    }
  }

  function getSearchText() {
    if (subscriptionList?.length > 0) {
      return homeCmsData?.bntStillSubscriptionLabel;
    }
    if (subscriptionList?.length === 0) {
      return homeCmsData?.btnSearchSubscriptionLabel;
    }
  }
  const handleRedirect = () => {
    dispatch({ type: ACTION_TYPES.RESET_STATE });
    history.push(`/account-engine`);
  };

  const declarer = (subNumber: any) => {
    dispatch(declarerSinistre(subNumber));
  };

  useEffect(() => {
    dispatch(getDataView(rulesContext));
  }, []);

  useEffect(() => {
    if (isReady === 0 && !!loading) {
      setReady(1);
    } else if (isReady === 1 && !loading) {
      setReady(2);
    }
  }, [loading]);

  useEffect(() => {
    if (viewDataitems?.dataRecoveryService?.find(service => service === 'GenericMobileHomeCustomer'))
      dispatch(getDocCMS('generic_mobile_home_customer_v2'));
    if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetActiveSubscriptionList'))
      dispatch(getActiveSubscriptionByClient());
    if (viewDataitems?.dataRecoveryService?.find(service => service === 'RecoverAndActiveSubscriptionsClients'))
      dispatch(recoverAndActiveSubscriptionsClients());
  }, [viewDataitems]);

  useEffect(() => {
    if (redirectLink && redirectLink === 'error') {
      setOpenModal(true);
    } else {
      if (redirectLink != null) {
        window.location.href = redirectLink;
      }
    }
    dispatch(emptyRedirectLink());
  }, [redirectLink]);

  return (
    <>
      {isReady < 2 ? (
        <HomeSkeleton />
      ) : (
        <>
          <div ref={refHeight}>
            <div className="avatar-header-container">
              <div className="avatar-header">
                <AvatarWithBadge hideButton avatar={avatar} title={[getAvatarText()]} />
              </div>
            </div>
          </div>
          <div className="scroll-y scrol-height-home">
            {subscriptionList?.length > 0 ? (
              <>
                <ConfComp
                  listCode={viewDataitems?.componentDataList}
                  code={'MOBILE_SUBSCRIPTION_LIST'}
                  props={{
                    data: subscriptionList || [],
                    getClaimsService: getClaims,
                    dataInfoCms: homeCmsData,
                    dataClaimCms: contractCmsData,
                    contractCustomerCms,
                    declarer,
                    claimLoading,
                    dataConfList,
                    multiClaims,
                    claimsList,
                  }}
                />
                {(viewDataitems?.componentDataList || []).find(x => x.componentDataKey === 'MOBILE_TO_ACCOUNT_ENGINE') && (
                  <ConfComp
                    listCode={viewDataitems?.componentDataList}
                    code={'MOBILE_TO_ACCOUNT_ENGINE'}
                    props={{
                      linkLabel: homeCmsData?.bntStillSubscriptionLabelLink,
                      actionLinkLabel: homeCmsData?.bntStillSubscriptionLabelActionLink,
                      handleRedirect,
                      isLink: true,
                    }}
                  />
                )}
              </>
            ) : (
              <>
                {(viewDataitems?.componentDataList || []).find(x => x.componentDataKey === 'MOBILE_TO_ACCOUNT_ENGINE') && (
                  <ConfComp
                    listCode={viewDataitems?.componentDataList}
                    code={'MOBILE_TO_ACCOUNT_ENGINE'}
                    props={{
                      buttonLabel: getSearchText(),
                      handleRedirect,
                    }}
                  />
                )}
              </>
            )}
          </div>

          <ModalWithAction
            icon={cmsModalInformation?.erreur_Icon?.url}
            showModal={openModal}
            setShowModel={setOpenModal}
            textBody={homeCmsData?.modal?.modal_msg_dont_declare_claim}
            action={() => {
              setOpenModal(false);
            }}
            btnActionLabel={cmsModalInformation?.CLOSE_button}
          />
        </>
      )}
    </>
  );
};

export default Home;
